export enum ListingTypeTexts {
    Exclusive = 'exclusive',
    CoExclusive = 'co-exclusive',
    Open = 'open',
    OursAlone = 'ours alone',
    Limited = 'limited'
}